export const USER_BASE_EVENT = `system:groups`;

export const USER_EVENT = <const>{
	INIT: `${USER_BASE_EVENT}:init`,
	INITIALIZED: `${USER_BASE_EVENT}:initialized`,
	EXTEND: `${USER_BASE_EVENT}:extend`,

	EDIT_GROUPS: `${USER_BASE_EVENT}:edit:groups`,
	LOGIN_AS: `${USER_BASE_EVENT}:loginAs`,
	NOTIFICATIONS: `${USER_BASE_EVENT}:notifications`,
	LOGIN_PUBLIC_ACCESS: `${USER_BASE_EVENT}:loginPublicAccess`,
};
